import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdDelete } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { FiAlertTriangle } from "react-icons/fi";
import Modal from 'react-bootstrap/Modal';
import { BASEAPIURL, token } from '../../env';

export default function News() {
    const navigate = useNavigate();

    const [newsList, setNewsList] = useState([]);

    // Form state
    const [newsTitle, setNewsTitle] = useState('');
    const [newsDescription, setNewsDescription] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, setFileName] = useState('Choose a file');
    const [fileUrl, setFileUrl] = useState(null);

    // Modal state
    const [show, setShow] = useState(false);
    const [show2, setShow2] = useState(false);
    const [showSM, setShowSM] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);
    const handleCloseSM = () => setShowSM(false);
    const handleShowSM = () => setShowSM(true);

    // Fetch newsletter list on load
    useEffect(() => {
        fetchNews();
    }, []);

    const fetchNews = async () => {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            tokenData: token
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        try {
            const response = await fetch(`${BASEAPIURL}/GetNewsLetter`, requestOptions);
            const result = await response.json();
            if (result?.data) setNewsList(result.data);
        } catch (err) {
            console.error("Error fetching news:", err);
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFileName(file.name);
            setSelectedFile(file);
            setFileUrl(URL.createObjectURL(file));
        } else {
            setFileName('Choose a file');
            setSelectedFile(null);
            setFileUrl(null);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!newsTitle || !newsDescription || !startDate || !endDate || !selectedFile) {
            alert("Please fill in all fields.");
            return;
        }

        const formdata = new FormData();
        formdata.append("token", token); // Use env or config
        formdata.append("Heading", newsTitle);
        formdata.append("Description", newsDescription);
        formdata.append("StartDate", startDate);
        formdata.append("EndDate", endDate);
        formdata.append("FileType", selectedFile);

        const requestOptions = {
            method: "POST",
            body: formdata,
            redirect: "follow"
        };

        try {
            const response = await fetch(`${BASEAPIURL}/InsertNewsLetter`, requestOptions);
            const result = await response.json();
            console.log("Insert result:", result);
            if (result.status === true) {
                alert("News added successfully!");
                handleClose();
                fetchNews(); // Refresh list
                // Clear form
                setNewsTitle('');
                setNewsDescription('');
                setStartDate('');
                setEndDate('');
                setSelectedFile(null);
                setFileUrl(null);
                setFileName('Choose a file');
            } else {
                alert("Failed to add news.");
            }
        } catch (err) {
            console.error("Error adding news:", err);
        }
    };

    return (
        <>
            <div className='scroll-box'>
                <div className='container-fluid g-0 mt-3'>
                    <div className='row d-flex justify-content-between align-items-center mb-2 g-0 py-2'>
                        <div className='col-4'>
                            <input
                                type="text"
                                placeholder="Search"
                                className="form-control form-control-sm"
                            />
                        </div>
                        <div onClick={handleShow} className='col-2 d-flex justify-content-center align-items-center p-2 rounded-1' style={{ backgroundColor: "#000", fontWeight: 400, color: "#fff", cursor: "pointer" }}>
                            + Add
                        </div>
                    </div>

                    <div className="row mt-2">
                        <div className="col-12 m-auto">
                            <div className='card-list-box-sr card p-2 border-0'>
                                <div className="table-responsive">
                                    <table className="table table-striped table-bordered table-sm align-middle ">
                                        <thead className="table-dark">
                                            <tr>
                                                <th>News Title</th>
                                                <th>News Description</th>
                                                <th>Start Date</th>
                                                <th>End Date</th>
                                                <th>Douement</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {newsList.length > 0 ? (
                                                newsList.map((news, index) => (
                                                    <tr key={index}>
                                                        <td>{news.Heading}</td>
                                                        <td>{news.Description}</td>
                                                        <td>{new Date(news.StartDate).toLocaleString()}</td>
                                                        <td>{new Date(news.EndDate).toLocaleString()}</td>
                                                        <td>
                                                            {news.Document ? (
                                                                <button
                                                                    className="btn btn-sm btn-outline-primary"
                                                                    onClick={() => {
                                                                        const byteCharacters = atob(news.Document.split(',')[1]);
                                                                        const byteNumbers = new Array(byteCharacters.length).fill().map((_, i) => byteCharacters.charCodeAt(i));
                                                                        const byteArray = new Uint8Array(byteNumbers);
                                                                        const blob = new Blob([byteArray], { type: 'application/pdf' });
                                                                        const blobUrl = URL.createObjectURL(blob);
                                                                        window.open(blobUrl, '_blank');
                                                                    }}
                                                                >
                                                                    View PDF
                                                                </button>
                                                            ) : (
                                                                "No File"
                                                            )}
                                                        </td>


                                                        <td>
                                                            <div className='d-flex justify-content-between' style={{ width: 50 }}>
                                                                <FaEdit onClick={handleShow2} style={{ cursor: "pointer", color: "#000" }} />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="6">No news available</td>
                                                </tr>
                                            )}
                                        </tbody>

                                    </table>

                                    {/* Add News Modal */}
                                    <Modal show={show} onHide={handleClose} size="lg">
                                        <Modal.Header closeButton>
                                            <Modal.Title>Add News</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <form onSubmit={handleSubmit}>
                                                <div className='row'>
                                                    <div className='col-lg-4'>
                                                        <label className='form-label'>News Title</label>
                                                        <input type='text' className='form-control' value={newsTitle} onChange={(e) => setNewsTitle(e.target.value)} required />
                                                    </div>
                                                    <div className='col-lg-4'>
                                                        <label className='form-label'>News Description</label>
                                                        <input type='text' className='form-control' value={newsDescription} onChange={(e) => setNewsDescription(e.target.value)} required />
                                                    </div>
                                                    <div className='col-lg-4'>
                                                        <label className='form-label'>Choose a File</label>
                                                        <input type="file" className="form-control" accept=".pdf,.doc,.docx,.txt" onChange={handleFileChange} required />
                                                        <small>{fileName}</small>
                                                        {fileUrl && <embed src={fileUrl} width="100%" height="100px" type="application/pdf" />}
                                                    </div>
                                                    <div className='col-lg-6 mt-2'>
                                                        <label className='form-label'>Start Date</label>
                                                        <input type="datetime-local" className="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)} min="1000-01-01T00:00"
                                                            max="9999-12-31T23:59" required />
                                                    </div>
                                                    <div className='col-lg-6 mt-2'>
                                                        <label className='form-label'>End Date</label>
                                                        <input type="datetime-local" className="form-control" value={endDate} onChange={(e) => setEndDate(e.target.value)} min="1000-01-01T00:00"
                                                            max="9999-12-31T23:59" required />
                                                    </div>
                                                </div>
                                                <div className='row mt-3'>
                                                    <div className='col-2 m-auto'>
                                                        <button type='submit' className='btn btn-dark w-100'>Save</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </Modal.Body>
                                    </Modal>

                                    {/* Edit Modal Placeholder */}
                                    <Modal show={show2} onHide={handleClose2} size="lg">
                                        <Modal.Header closeButton>
                                            <Modal.Title>Edit News (Coming Soon)</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>Editing functionality is not yet implemented.</Modal.Body>
                                    </Modal>

                                    {/* Delete Confirmation Modal */}
                                    <Modal size="sm" show={showSM} onHide={handleCloseSM}>
                                        <Modal.Header closeButton>
                                            <Modal.Title><FiAlertTriangle style={{ color: "orangered" }} /></Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <div className="text-center" style={{ fontSize: "16px", color: '#1f5156', fontWeight: 500 }}>
                                                Are you sure you want to delete?
                                            </div>
                                            <div className='d-flex justify-content-between mt-3'>
                                                <div onClick={handleCloseSM} className='btn btn-success w-100 me-2'>Yes</div>
                                                <div onClick={handleCloseSM} className='btn btn-danger w-100'>No</div>
                                            </div>
                                        </Modal.Body>
                                    </Modal>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
